export const ACCOUNT_TOTALS_PATH = '/account/totals';
export const ACCOUNT_TOTALS_BY_ACCOUNT_PATH = '/account/:accountNumber/totals';
export const ACCOUNT_AUTHORIZATIONS_PATH = '/account/:accountNumber/authorizations';
export const ACCOUNT_REFUND_PATH = '/account/refund';
export const ACCOUNT_DISTRIBUTION_PATH = '/account/distribution';
export const ACCOUNT_TRANSFER_HISTORY_PATH = '/account/transfers';
